export default {
  headers: [
    ['satellite-tracking/report.vehicle_name', 'registration'],
    ['satellite-tracking/report.drivers', 'driver'],
    ['satellite-tracking/report.date', 'dateTime'],
    ['satellite-tracking/report.address', 'address'],
    ['satellite-tracking/report.speed', 'speed'],
    ['satellite-tracking/report.duration', 'duration'],
    ['satellite-tracking/report.latitude', 'lat'],
    ['satellite-tracking/report.longitude', 'lng'],
    ['satellite-tracking/report.distance', 'distance'],
    ['satellite-tracking/report.event_type', 'event'],
    ['satellite-tracking/report.odometer', 'odometer'],
    ['satellite-tracking/report.fuel_level', 'fuel']
  ]
}
